import { TipoMaterialService } from './../../shared/services/tipo-materiales.service';
import { UnidadMedidaService } from './../../shared/services/unidad-medida.service';
import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { MenuFuncionService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes, MaterialDto, SaveMaterialDto, UnidadMedidaDto, TipoMaterialDto, SearchUnidadMedidaRequest, SearchTipoMaterialRequest, DialogConfirmRequest, DialogConfirmResponse } from '../../../../src/app/shared/model';
import { MaterialesService } from './../../shared/services/materiales.service';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-materiales-edit',
  templateUrl: './materiales-edit.component.html',
  styleUrls: ['./materiales-edit.component.scss']
})
export class MaterialesEditComponent implements OnInit {
  formGroup: FormGroup;
  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoSearching: boolean = false;
  isUnidadMedidaSearching: boolean = false;
  isTipoMaterialSearching: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  msgError: string = "";
  item: MaterialDto;
  unidadMedidaList:UnidadMedidaDto[];
  tipoMaterialList:TipoMaterialDto[];

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private materialesService: MaterialesService,
    private unidadMedidaService: UnidadMedidaService,
    private tipoMaterialService: TipoMaterialService
  ) { }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.MATERIAL).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.MATERIAL_EDIT);
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.MATERIAL_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.MATERIAL_LIST);
        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.MATERIAL_DELETE);
        this.loadView();
      } else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();

    this.loadEntity();

    this.getUnidadMedida();
    this.getTipoMaterial();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Codigo': [null, [Validators.maxLength(100)]],
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'UnidadMedidaMaterialId': [null, Validators.required],
      'TipoMaterialId': [null, Validators.required],
      'MontoTopeSinPresupuesto': [null],
      'Activo': [true, Validators.required]
    });
  }

  getUnidadMedida() {
    var r = new SearchUnidadMedidaRequest(null, null, true, "Nombre", null, null, true);
    this.isUnidadMedidaSearching = true;

    this.unidadMedidaService.search(r).subscribe(data=> {
      this.isUnidadMedidaSearching = false;
      this.unidadMedidaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadMedidaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTipoMaterial() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.isTipoMaterialSearching = false;
      this.tipoMaterialList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
            if(this.canEdit || this.canView) {
              this.isSearching = true;
              this.materialesService.get(id).subscribe(data => {
                this.isSearching = false;
                if (data != null && data.Success) {
                  this.item = data.Result;

                if (this.item != null && this.item.Id > 0) {
                  this.formGroup.patchValue(this.item);
                }
                else
                  this.msgError = "No se encontró el item seleccionado.";
              }
              else
              this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.item = new MaterialDto(0, null, null,null,null,null,null,true);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorUnidadMedida() {
    var v = this.formGroup.get('UnidadMedidaMaterialId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorTipoMaterial() {
    var v = this.formGroup.get('TipoMaterialId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveMaterialDto(null, null,null ,true);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo
      }
    };

    this.isSaving = true;
    this.materialesService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDelete() {
    if (!this.canDelete)
      return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el material?", null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.materialesService.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  onCancel() {
    this.location.back();
  }
}
